import { Controller } from "stimulus"
import AOS from 'aos';

export default class extends Controller {
	static targets = [ "topButton" ]

  connect() {
		this.fonts
    this.mobileNav
    this.aos
    this.scrollToTopButton
  }

  get fonts() {
    var WebFont = require('webfontloader')
    WebFont.load({
      typekit: { id: 'rfl5ykw' }
    });
  }

  get mobileNav() {
    var openButton = document.querySelector('[data-behavior~=open-nav]');
    var closeButton = document.querySelector('[data-behavior~=close-nav]');

    openButton.addEventListener('click', function(el) {
      el.preventDefault();
      document.querySelector('[data-behavior~=mobile-nav]').style.height = "100%";
    })

    closeButton.addEventListener('click', function(el) {
      el.preventDefault();
      document.querySelector('[data-behavior~=mobile-nav]').style.height = "0%";
    })
  }

  get aos() {
    AOS.init({
      offset: 200,
      duration: 900,
      easing: 'ease-in-out',
      delay: 100,
      once: true,
    });
  }

  get scrollToTopButton() {
    let topButton = this.topButtonTarget

    window.onscroll = function() {scrollFunction()};
    function scrollFunction() {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
				topButton.style.visibility = "visible";
        topButton.style.opacity = "1";
      } else {
        topButton.style.visibility = "hidden";
        topButton.style.opacity = "0";
      }
    }
  }

  gotoTop() {
		Velocity(document.body, "scroll", {offset: "0", mobileHA: false});
  }
}

